import { useNavigate, useParams } from 'react-router-dom-v6'
import { Skeleton } from '@clouway/ui'

import { NetworkEditForm, type NetworkFormValues } from '../components/NetworkEditForm'
import { useNetwork, useUpdateNetwork } from '../hooks'

export function UpdateNetwork() {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: network, isLoading } = useNetwork(id)
  const { mutateAsync: update } = useUpdateNetwork()

  const onSubmit = async (values: NetworkFormValues) => {
    await update({ id, input: values })
    navigate('/networks')
  }

  if (isLoading || !network) return <Skeleton className="mx-auto h-80 w-full max-w-2xl" />

  return (
    <NetworkEditForm
      initialValues={{ name: network.name, apn: network.apn, user: network.user, pass: network.pass }}
      onSubmit={onSubmit}
    />
  )
}
